const RESIZER_CLASS = "ct-resizer";
const SHADOWDOM_CLASS = "ct-web-dangers-shadow-wrapper"; // basic中会去去掉它

const POPOVER_CLASS = "ct-toolbox-popover";
const WEB_REG = /^https?:\/\/[^/]+/;
const BORDER_CACHE_FIELD = "image-border-cache";
const IMAGE_MIN_WIDTH = 20; // 图片最小宽度（小于这个宽度将无法再缩小）

const IMAGE_MAX_HEIGHT = 600;
const IMAGE_INFO_DISPLAY_MIN_WIDTH_SIZE = 80; // 显示图片信息的最小尺寸（小于这个尺寸将不显示图片大小信息）

const IMAGE_INFO_DISPLAY_MIN_HEIGHT_SIZE = 35; // 显示图片信息的最小尺寸（小于这个尺寸将不显示图片大小信息）

const IMAGE_OFFSET = 4; // margin(4) && border(2)

const IMAGE_DEFAULT_WIDTH = 100; // 没有宽高时的默认值

const IMAGE_DEFAULT_HEIGHT = 100; // 没有宽高时的默认值

const CITADELREG = /^https?:\/\/([0-9a-zA-Z\-]+(-sl-))?km\.(it\.(dev|test|beta|st)\.)?sankuai\.com/;

export { RESIZER_CLASS, SHADOWDOM_CLASS, POPOVER_CLASS, WEB_REG, BORDER_CACHE_FIELD, IMAGE_MIN_WIDTH, IMAGE_MAX_HEIGHT, IMAGE_INFO_DISPLAY_MIN_WIDTH_SIZE, IMAGE_INFO_DISPLAY_MIN_HEIGHT_SIZE, IMAGE_OFFSET, IMAGE_DEFAULT_WIDTH, IMAGE_DEFAULT_HEIGHT, CITADELREG };
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/@mtfe/citadel-editor/es/consts/index.js